module.exports = __webpack_public_path__ + "08_mustache_brown.7c7a43f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer3/08_mustache_brown.png
// module id = AcYh
// module chunks = 0